import React, { useEffect } from "react";
import {
  Grid,
  Form,
  Icon
} from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import {updateShipmentFieldValue,updateTransportationHeaderInfo} from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import { convertDateToUTC,convertDateToUTCEpoch } from "../../../Helper/date"
import { selectDecType,selectTransmisisonTypeUsingDeclStatus,selectTransmissionTypeVal,selectDeclarationType,selectMrnNo } from "../../selectors";
import { useUpdateEffect } from "../../../hooks";
import { TranslateContext } from "../TranslateContext";
import { useValidateAcceptDateUsingDecType } from "../../hooks/AGS/useValidateAcceptDateUsingDecType";
import PopUpIcon from "../../../commonComponents/formComponents/PopUpIcon";
import { DMSCRE } from "../util";
import { ducrKey } from "../../util/NL_fieldPatterns";


const HeaderLevelInfo=({fieldPattern,validateError,lastShipmentState,saveForm,isTransmissionTypeEXT,isDMS,isImportShipment,declarationStatus,exitInfoStatus:{disabled,exitInfoCurrentStatus}})=> {
  const dispatch = useDispatch();
  const declarationList = useSelector((state) => isImportShipment ? state.DropDownValues.impDeclarations :state.DropDownValues.expDeclarations);
  const procedureList=useSelector((state) => isImportShipment ? state.DropDownValues.impProcedures :state.DropDownValues.expProcedures);
  const DeclarationTypeList=useSelector((state)=>selectDecType(state,isImportShipment))
 const TransmissionTypeList=useSelector((state)=>selectTransmisisonTypeUsingDeclStatus(state,{isImportShipment,decStatus:declarationStatus,isDMS}))
  const transmissionType=useSelector((state)=>selectTransmissionTypeVal(state))
  const declarationType=useSelector((state)=>selectDeclarationType(state))
  const reasonCodes=useSelector((state) => state.DropDownValues.reasonCodes);
  const mrn=useSelector((state)=>selectMrnNo(state))
  const {ducr,acceptanceEpoch,releaseEpoch,euExitEpoch,cancellationReason,procedure,arrivalEpoch,declaration,reason} = useSelector((state) => state.Shipment?.exitInfo || {});
  const {validationMsg}=useValidateAcceptDateUsingDecType(declarationType,isImportShipment,isDMS,acceptanceEpoch)
  const shipmentId= useSelector((state) => state.Shipment.shipmentId);
  const ducrError=useSelector((state)=>state.ValidationErrors.header?.[ducrKey]?.msg)
  const saveData=(params)=>saveForm({exitInfo:params})
  const translate = React.useContext(TranslateContext).translate
  
  const filteredDeclarationList=React.useMemo(()=>{
    return isDMS ? declarationList.filter(c=>c.procedure.includes(procedure)) :declarationList
  },[procedure,declarationList,isDMS])
  
  const columnWidth=isDMS ? "4" :"5"
  const isNewShipment=declarationStatus==DMSCRE // we need to update dec type and transmisison type in case of new shipment if it is not present
  const isCancel=transmissionType=="CAN"
  useEffect(()=>{
    if(isNewShipment)
    {
      const params={}
       if(!declarationType) 
          params.declarationType="A"
       
       if(!transmissionType)
         params.transmissionType="DEC"
    
    if(Object.keys(params).length>0){
         saveData(params)
         dispatch(updateShipmentFieldValue(params))
    }
    }
     
  },[isNewShipment])

  useUpdateEffect(()=>{
    if(isDMS){
    const updateAdditonalParams={}
     if(filteredDeclarationList?.length==1){ // if length is 1 then update default value of declaration
      updateAdditonalParams.declaration=filteredDeclarationList[0]?.value
     }
     else{
      updateAdditonalParams.declaration=" " // clear if procedure is blank
     }
    saveData({procedure:procedure,...updateAdditonalParams})
    dispatch(updateShipmentFieldValue({...updateAdditonalParams}) )
    }
  },[procedure])
  
  return (
    <Form.Group className="float-container">
       <Grid className="kn__grid">
      

      <Grid.Row>
       
        {
          isDMS && <Grid.Column width="4" className="divFormFeild">
        <DropDown
            id="procedure"
            label={translate("PROCEDURE")}
            className="field-bg dropdown100"
            labelClass="text-none"
            isLabel={true}
            data={procedureList}
            clearable
            value={procedure}
            onChange={
              (value) =>dispatch(updateShipmentFieldValue({"procedure":value}) )
            } 
          />
         
        </Grid.Column>
      }
        <Grid.Column width={columnWidth} className="divFormFeild">
          <DropDown
            id="declaration"
            label={translate("DECLARATION",{ ns: ['header'] })}
            className="field-bg dropdown100"
            labelClass="text-none"
            value={declaration}
            isLabel={true}
            data={filteredDeclarationList}
            boxNumber="1"
           // disabled={true}
            onChange={(value) =>{
              saveForm({exitInfo:{declaration:value},transportation:{destinationCountry:" "}})
              dispatch(updateShipmentFieldValue({declaration:value}))
              dispatch(updateTransportationHeaderInfo({destinationCountry:""}))
            } }
           
          />
        </Grid.Column>
        <Grid.Column width={columnWidth} className="divFormFeild">
        <DropDown
        id="decType"
        label={translate("DEC_TYPE", { ns: ['header'] })}
        direction="left"
        data={DeclarationTypeList}
        className="field-bg dropdown100"
        value={declarationType}
       onChange={(value) => {

         if(["SUP","PRE"].includes(transmissionType) && !isImportShipment){ // this condition is applied because in case of SUP and Pre transmission type depends on decType
          saveData({declarationType:value,transmissionType:" "})
          dispatch(updateShipmentFieldValue({declarationType:value,transmissionType:""}))
        }
         else{
         saveData({declarationType:value})
         dispatch(updateShipmentFieldValue({declarationType:value}))} 
       }
      }   
      
    />
         
        </Grid.Column>
        <Grid.Column width={isDMS ? columnWidth : 6} className="divFormFeild">
      <DropDown
        id="transmissionType"
        label={translate("TRANSMISSION_TYPE", {ns: "header"})}
        data={TransmissionTypeList}
        className="field-bg dropdown100"
        value={transmissionType}
        clearable
       onChange={(value) => {
        const updateOtherFields={}
        if(!isImportShipment){
        if(value=="SUP"){
           if(["B","E"].includes(declarationType)){
            updateOtherFields.declarationType="X"
           }
           else if (["C","F"].includes(declarationType)){
            updateOtherFields.declarationType="Y"
           }
        }
      }
       if(cancellationReason){ // clear cancellation reason if already filled if trans type<>CAN
        updateOtherFields.cancellationReason=" "
       }  
       if(!isDMS){ // only for AGS we don't have reason on DMS
        if(reason){ // clear cancellation reason if already filled if trans type<>CAN
          updateOtherFields.reason=" "
         }
       }
        saveData({transmissionType:value,...updateOtherFields})
         dispatch(updateShipmentFieldValue({transmissionType:value,...updateOtherFields}))} 
       }   
       isDisabled={lastShipmentState}
     // {...isTransEnabled}
    />
          
        </Grid.Column>
 
      </Grid.Row>
     
      </Grid>

    <Grid className="kn__grid">
      

              <Grid.Row>
                <Grid.Column width="5" className="divFormFeild b-bw-1">
                  <InputField
                    isLabel={false}
                    errors={ducrError}
                    id="ducr"
                    type="text"
                    label="ducr"
                    className="field-bg"
                    value={ducr}
                    clearInput={false}
                    onChange={(value) =>dispatch(updateShipmentFieldValue({"ducr":value}))}
                    onBlur={(value) =>{
                      saveData({ducr:ducr || " "})
                      validateError({[`${ducrKey}`]:""},{exitInfo:{ducr}},{[`${ducrKey}`]:fieldPattern()?.header[ducrKey]})
                    }}
                  
                  />
                </Grid.Column>
                <Grid.Column
                  width="5"
                  className="divFormFeild"
                >
                  <InputField
                    isLabel={false}
                    id={`shipmentId`}
                    type="text"
                    label={translate("SHIPMENT_NUMBER")}
                    value={shipmentId}
                    boxNumber="7"
                    className="field-bg"
                    clearInput={false}
                    disabled={true}
                    onChange={(value) =>dispatch(updateShipmentFieldValue({shipmentId:value}))}
                    onBlur={(value) =>saveData({shipmentId})
                    }
                   
                  />
                </Grid.Column>
                <Grid.Column
                  width="3"
                  className="divFormFeild"
                >
                  <InputField
                    isLabel={false}
                    id="mrn"
                    type="text"
                    label="MRN"
                    value={mrn}
                    className="field-bg"
                    clearInput={false}
                    disabled={true}
                    onChange={(value) =>dispatch(updateShipmentFieldValue({mrn:value})) }
                    onBlur={(value) => saveData({mrn})}
                   
                  />
                </Grid.Column>    
           
                    <Grid.Column
                      width="3"
                      className="divFormFeild datepicker1 b-bw-1"
                     
                    >
                      
                      <InputField  
                id="arrivalDate"
                name="arrivalDate"
                type="date"
                label={translate("DATE_OF_ARRIVAL", {ns:"header"})}
                className="field-bg"
                isLabel={false}
                clearInput={false}
                value={convertDateToUTC(arrivalEpoch)} 
                onChange={(value) => {
                  value=convertDateToUTCEpoch(value)
                  dispatch(updateShipmentFieldValue({arrivalEpoch:value}));
                  saveData({"arrivalEpoch":value})
                  
                     }}
              />
                      
                    </Grid.Column>

              </Grid.Row>
              
                    <Grid.Row >
                    <Grid.Column
                      width="5"
                      className="divFormFeild datepicker1 b-bw-1" 
                  
                    >
                        <InputField  
                id="acceptanceDate"
                name="acceptanceDate"
                type="date"
                label={
                  <React.Fragment>
                 {
                validationMsg  && 
                  <PopUpIcon className="errorIcon"
                  color="red" icon="exclamation triangle circle"
                  popupText={validationMsg} />
                  } 
          
                  {translate("DATE_OF_ACCEPTANCE", {ns:"header"})}
                  </React.Fragment>

                  }
               // errors={[validationMsg]}
                className="field-bg"
                isLabel={false}
                clearInput={false}
                value={ convertDateToUTC(acceptanceEpoch)} 
                onChange={(value) => {
                  value=convertDateToUTCEpoch(value)
                  dispatch(updateShipmentFieldValue({acceptanceEpoch:value}));
                  saveData({"acceptanceEpoch":value})
                  
                     }}
              
              />
                     
                    </Grid.Column>
                    <Grid.Column width="5" className="divFormFeild datepicker1 b-bw-1" >

                <InputField  
                id="releaseDate"
                name="releaseDate"
                type="date"
                label={translate("DATE_OF_RELEASE", {ns:"header"})}
                className="field-bg"
                disabled={true}
                isLabel={false}
                clearInput={false}
                value={ convertDateToUTC(releaseEpoch)} 
          
                onChange={(value) => {
                  value=convertDateToUTCEpoch(value)
                  dispatch(updateShipmentFieldValue({releaseEpoch:value}));
                  saveData({"releaseEpoch":value})
                  
                     }}
              />
                     
                    </Grid.Column>
               
                   
                <Grid.Column width="6" className="divFormFeild datepicker1 b-bw-1">
                  {!isImportShipment &&
                      <InputField  
                            id="exitEUDate"
                            name="exitEUDate"
                            type="date"
                            label={
                              <React.Fragment>
                              {exitInfoCurrentStatus && isTransmissionTypeEXT && <Icon style={{display:"contents"}} name="exclamation triangle" color={exitInfoCurrentStatus.color}></Icon>
                            }
                                {translate("EXIT_EU_DATE", {ns:"header"})}
                              </React.Fragment>
                            }
                            className="field-bg"
                            isDisabled={!isTransmissionTypeEXT || lastShipmentState || disabled}
                            clearInput={false}
                            value={ convertDateToUTC(euExitEpoch)} 
                            onChange={(value) => {
                              value=convertDateToUTCEpoch(value)
                              dispatch(updateShipmentFieldValue({euExitEpoch:value}));
                              saveData({"euExitEpoch":value})
                              
                                }}
              />
                    }
                    </Grid.Column>
              </Grid.Row>
              {
               (isCancel || transmissionType=="SUP") && <Grid.Row>
                 {
                   !isDMS && <Grid.Column width={isCancel ? 8 :16} className="divFormFeild">
                <DropDown
                    id="reason"
                    label={translate("Reason")}
                    className="field-bg dropdown100"
                    labelClass="text-none"
                    value={reason}
                    isLabel={true}
                    clearable
                    isDisabled={lastShipmentState}
                    data={reasonCodes}
                    onChange={(value) =>{
                      saveData({reason:value})
                      dispatch(updateShipmentFieldValue({reason:value}))}
                    }
                    />
          </Grid.Column>
          }
               {
               (isCancel || isDMS) && <Grid.Column width={isDMS ? 16 : 8} className="divFormFeild">
                <InputField
                    isLabel={false}
                    id="cancellationReason"
                    type="text"
                    label={translate("CANCELLATION_REASON", {ns:"header"})}
                    className={"field-bg"}
                    value={cancellationReason}
                    clearInput={false}
                    isDisabled={lastShipmentState}
                    onChange={(value) =>dispatch(updateShipmentFieldValue({cancellationReason:value}))}
                    onBlur={(value) =>saveData({cancellationReason:cancellationReason || " "})}
                  />
                </Grid.Column>
}
              </Grid.Row>
}
              </Grid>
  </Form.Group>
  );
}

export default React.memo(HeaderLevelInfo)
